const normalize = (value) => String(value || "").trim().replace(/\s+/g, " ").toLowerCase();

export function inventoryMatches(row, { city, oem, dealer }) {
  return (!city || normalize(row.city) === normalize(city))
    && (!oem || normalize(row.oem) === normalize(oem))
    && (!dealer || normalize(row.dealer) === normalize(dealer));
}

export function availableInventoryUnits(rows, selection) {
  return rows
    .filter((row) => inventoryMatches(row, selection))
    .reduce((sum, row) => sum + (Number(row.inventory_yearly) || 0), 0);
}
